import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M17.4537 16.6667C19.0372 14.8975 20 12.5612 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 12.5612 0.962845 14.8975 2.54631 16.6667C4.37738 18.7125 7.03833 20 10 20C12.9617 20 15.6226 18.7125 17.4537 16.6667Z"
      fill="#23383A"
    />
    <path
      d="M4.45855 13.3977C5.68103 11.2645 7.95164 9.94872 10.4103 9.94872C12.8689 9.94872 15.1395 11.2645 16.362 13.3977L16.4483 13.5483C16.672 13.9386 16.6325 14.4308 16.3212 14.7554C14.7583 16.3848 12.7977 17.3846 10.4103 17.3846C8.02284 17.3846 6.06218 16.3848 4.49933 14.7554C4.18797 14.4308 4.14856 13.9386 4.37221 13.5483L4.45855 13.3977Z"
      fill="#75F9FB"
    />
    <path
      d="M7.07692 5.33333C7.07692 3.49238 8.56931 2 10.4103 2C12.2512 2 13.7436 3.49238 13.7436 5.33333C13.7436 7.17428 12.2512 8.66667 10.4103 8.66667C8.56931 8.66667 7.07692 7.17428 7.07692 5.33333Z"
      fill="#75F9FB"
    />
  </svg>,
  'AccountV1Icon',
);
